import { z } from "zod";
export const ZMongoIdStr = z.string().regex(/^[0-9a-fA-F]{24}$/, "Invalid ObjectId");
const isObjectIdLike = (value) => typeof value?.toHexString === "function";
export const ZObjectIdString = z
    .union([ZMongoIdStr, z.custom(isObjectIdLike).transform((value) => value.toHexString())])
    .pipe(ZMongoIdStr);
export const ZGroupEnum = z.enum(["ADMIN", "INTERNAL", "PARTNER", "CLIENT"]);
export const ZUserPartial = z.object({
    _id: ZObjectIdString,
    name: z.string(),
});
export const ZAccessLevel = z.enum(["PROJECT", "USERS", "GROUPS"]).describe("AccessLevels");
export const ZAccess = z.object({
    level: ZAccessLevel,
    groups: z.array(ZGroupEnum),
    users: z.array(ZObjectIdString),
});
export const ZAccessPopulated = ZAccess.extend({
    users: z.array(ZUserPartial),
});
